import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { porteroLogin, isPorteroAuth } from '../../lib/porteroApi';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { toast } from 'sonner';
import { Radio, Loader2, LogIn } from 'lucide-react';
import { PorteroInstallBanner } from '../../components/portero/PorteroInstallBanner';

export default function PorteroLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isPorteroAuth()) navigate('/portero/panel', { replace: true });
    // Swap all PWA meta for portero
    const link = document.querySelector('link[rel="manifest"]');
    if (link) link.setAttribute('href', '/portero-manifest.json');
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', '#09090b');
    const appName = document.querySelector('meta[name="application-name"]');
    if (appName) appName.setAttribute('content', 'Portero GPS');
    const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (appleTitle) appleTitle.setAttribute('content', 'Portero GPS');
    document.querySelectorAll('link[rel="apple-touch-icon"]').forEach(l => l.setAttribute('href', '/portero-icon-192.png'));
    const fav = document.querySelector('link[rel="icon"]');
    if (fav) fav.setAttribute('href', '/portero-icon-192.png');
    document.title = 'Portero GPS';
    return () => {
      if (link) link.setAttribute('href', '/manifest.json');
      if (meta) meta.setAttribute('content', '#1a1a1a');
    };
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await porteroLogin(email, password);
      toast.success(`Bienvenido, ${data.user.nombre}`);
      navigate('/portero/panel');
    } catch (err) {
      toast.error(err.message || 'Credenciales inválidas');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-emerald-500 mx-auto flex items-center justify-center mb-4">
            <Radio className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-2xl font-black text-white tracking-tight">PORTERO GPS</h1>
          <p className="text-zinc-500 text-sm mt-1">Telecontrol por comandos GPRS</p>
        </div>

        <Card className="bg-zinc-900 border-zinc-800">
          <CardHeader className="pb-4">
            <CardTitle className="text-white text-lg">Acceso</CardTitle>
            <CardDescription className="text-zinc-500">Ingresa con tus credenciales 4sat.cl</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label className="text-zinc-300">Email</Label>
                <Input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="usuario@4sat.cl"
                  className="bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-600"
                  required data-testid="portero-login-email"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-zinc-300">Contraseña</Label>
                <Input
                  type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-600"
                  required data-testid="portero-login-password"
                />
              </div>
              <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" disabled={loading} data-testid="portero-login-submit">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><LogIn className="h-4 w-4 mr-2" />Ingresar</>}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-zinc-600 text-xs">multisistemas.cl</p>
      </div>

      {/* PWA Install Banner */}
      <PorteroInstallBanner />
    </div>
  );
}
